/* eslint-disable quote-props */
import apiRoutes from 'core/apiRoutes';

export default {
  ...apiRoutes,

  // Users
  'user-edit-index': '/content/admin/users/edit/',
  'user-edit': '/content/admin/users/edit/:id/',

  // Wistia
  'wistia-project':
    'https://tutorondemand-1.wistia.com/projects/:projectHashedId',

  // Wistia via API
  'api:wistia-project-media': '/api/v1/wistia/projects/:projectHashedId.json',
  'api:wistia-project-list': '/api/v1/wistia/projects.json',

  // Clone tool
  'api:clone:duplication-records':
    '/api/v1/clone/duplication_records/:app/:model/:objectId/',

  // Other API
  'api:branch-lesson-list': '/api/v1/branch/:branchId/lessons/',
  'api:exam-builder': '/api/v1/exam-builder/',
  'api:exam-builder-detail': '/api/v1/exam-builder/:examId/',
  'api:exam-detail-reopen': '/api/v1/exams/:examId/reopen/',

  'api:delete:activities:responses':
    '/api/v1/activities/activities/:activityId/activity_responses/',

  // API for signed file uploads
  'api:asset-upload-form': '/api/v1/asset_upload_form/',
  'api:upload-asset-to-private-storage':
    '/api/v1/upload_asset_to_private_storage/',

  'api:get:load-syllabus': '/api/v1/syllabuses/:syllabusId/',

  // Admin
  'admin:exam-change': '/secret/exams/exam/:id/',
  'admin:school-class-change':
    '/secret/profiles/schoolclass/:schoolClassId/change/',
  'admin:lesson-change': '/secret/tod/lesson/:id/',
  'admin:branch-change': '/secret/tod/branch/:id',
  'admin:payments-lock-list-item-change':
    '/secret/payments/paymentlocklistitem/:id/',
  'admin:activity-change': '/secret/activities/activity/:id/',

  // Content
  'content-admin': '/content/admin/',
  'content:wistia': '/content/admin/wistia/',
  'content:exam-create': '/content/admin/exams/create/',
  'content:exam-create-1': '/content/admin/exams/create/1/',
  'content:exam-create-2': '/content/admin/exams/create/2/',
  'content:exam-edit': '/content/admin/exams/edit/',
  'content:exam-editId': '/content/admin/exams/edit/:id/',
  'content:course-create': '/content/admin/courses/create/',
  'content:course-create-1': '/content/admin/courses/create/1/',
  'content:course-create-2': '/content/admin/courses/create/2/',
  'content:course-created': '/content/admin/courses/created/',
  'content:course-edit': '/content/admin/courses/edit/',
  'content:course-editId': '/content/admin/courses/edit/:id/',
  'content:lesson-edit': '/content/admin/lessons/edit/:id/',
  'content:captions': '/content/admin/captions/',
  'content:captions-courseId': '/content/admin/captions/:courseId/',
  'content:captions-review': '/content/admin/captions/review/',
  'content:captions-review-courseId':
    '/content/admin/captions/review/:courseId/',
  'content:activities:create': '/content/admin/activity/',
  'content:activities:edit': '/content/admin/activity/edit/',
  'content:activities:edit-activityId':
    '/content/admin/activity/edit/:activityId/',
  'content-admin:generate-anonymous-trial-accounts':
    '/content/admin/anon-trial-accounts/',
  'content-admin:generate-anonymous-trial-classes':
    '/content/admin/anon-trial-classes/',
  'content-admin:profiles-without-email-at-domain-report':
    '/content/admin/profiles-without-email-at-domain-report/',
  'content-admin:profiles-without-email-at-domain-report-csv':
    '/content/admin/profiles-without-email-at-domain-report/?format=csv',

  // Captions
  'content:captions-order': '/content/admin/captions/:courseId/',

  // School uploader
  'school-uploader:edval': '/school-uploader/edval-upload/',
  'school-uploader:edrolo': '/school-uploader/edrolo-upload/',
  'school-uploader:timetabler-post-9':
    '/school-uploader/timetabler-post-9-upload/',
  'school-uploader:timetabler-pre-9':
    '/school-uploader/timetabler-pre-9-upload/',
  'school-uploader:firstclass-csv': '/school-uploader/firstclass-csv-upload/',
  'school-uploader:griddle': '/school-uploader/griddle-upload/',
  'school-uploader:timechart': '/school-uploader/timechart-upload/',

  // enrolinator API
  'enrolinator:import_datasets': '/enrolinator/datasets/?year=:year',
  'enrolinator:reconciled_import_datasets':
    '/enrolinator/datasets/reconciled/?year=:year',
  'enrolinator:reconciled_import_datasets_csv':
    '/enrolinator/datasets/reconciled/csv/?year=:year',
  'enrolinator:import_dataset': '/enrolinator/datasets/:id/',
  'enrolinator:import_dataset_reconciliation':
    '/enrolinator/datasets/:id/reconciliation/',
  'enrolinator:import_dataset_recall': '/enrolinator/datasets/recall/',
  'enrolinator:acquire_lock': '/enrolinator/datasets/:id/lock/',
  'enrolinator:import_dataset_modify': '/enrolinator/datasets/:id/modify/',
  'enrolinator:feed_import_dataset_to_bot': '/enrolinator/datasets/:id/bot/',
  'enrolinator:school_class_reconciliation':
    '/enrolinator/datasets/:id/school_class_reconciliation/',
  'enrolinator:ignore_school_classes':
    '/enrolinator/datasets/:id/ignore_school_classes/',
  'enrolinator:unignore_school_classes':
    '/enrolinator/datasets/:id/unignore_school_classes/',
  'enrolinator:unmanage_school_classes':
    '/enrolinator/datasets/:id/unmanage_school_classes/',
  'enrolinator:unmanage_profiles':
    '/enrolinator/datasets/:id/unmanage_profiles/',
  'enrolinator:target_school_classes':
    '/enrolinator/datasets/:id/target_school_classes/',
  'enrolinator:teacher_reconciliation':
    '/enrolinator/datasets/:id/teacher_reconciliation/',
  'enrolinator:manual_teacher_couplings':
    '/enrolinator/datasets/:id/manual_teacher_couplings/',
  'enrolinator:ignore_teachers': '/enrolinator/datasets/:id/ignore_teachers/',
  'enrolinator:unignore_teachers':
    '/enrolinator/datasets/:id/unignore_teachers/',
  'enrolinator:manual_student_couplings':
    '/enrolinator/datasets/:id/manual_student_couplings/',
  'enrolinator:student_reconciliation':
    '/enrolinator/datasets/:id/student_reconciliation/',
  'enrolinator:classroom_role_reconciliation':
    '/enrolinator/datasets/:id/classroom_role_reconciliation/',
  'enrolinator:enrolment_reconciliation':
    '/enrolinator/datasets/:id/enrolment_reconciliation/',
  'enrolinator:logs': '/secret/enrolinator/log/?import_dataset_id=:id',
  'enrolinator:logs-errors':
    '/secret/enrolinator/log/?import_dataset_id=:id&level__exact=ERROR:extra',
  'enrolinator:logs-csv': '/enrolinator/logs/:year/csv/',

  // enrolinator content
  'content:enrolinator': '/content/admin/enrolinator/',
  'content:enrolinator:import_datasets': '/content/admin/enrolinator/datasets/',
  'content:enrolinator:school_class_reconciliation':
    '/content/admin/enrolinator/datasets/:id/school_class_reconciliation/',
  'content:enrolinator:teacher_reconciliation':
    '/content/admin/enrolinator/datasets/:id/teacher_reconciliation/',
  'content:enrolinator:student_reconciliation':
    '/content/admin/enrolinator/datasets/:id/student_reconciliation/',
  'content:enrolinator:role_reconciliation':
    '/content/admin/enrolinator/datasets/:id/role_reconciliation/',

  // payments
  'payments:students-owing-report-index':
    '/content/admin/payments/students-owing-report/:calendarYear/',
  'payments:students-owing-report':
    '/content/admin/payments/students-owing-report/:calendarYear/:schoolId/',
  'payments:students-owing-by-class-report':
    '/api/v1/payment/report/students_owing_by_class/:calendarYear/:schoolId/',
  'payments:students-owing-by-class-report-index':
    '/api/v1/payment/report/students_owing_by_class/:calendarYear/',
  'payments:students-owing-by-class-report-csv':
    '/api/v1/payment/report/students_owing_by_class/:calendarYear/:schoolId/csv/',
  'payments:refunds-owed-report':
    '/content/admin/payments/refunds-owed-report/:calendarYear/',
  'payments:refund-processes':
    '/content/admin/payments/refund-processes/:calendarYear/',
  'payments:csv-credit': '/api/v1/payment/admin/csv_credit/',
  'payments:school-collections-batch-run-report-index':
    '/api/v1/payment/report/school-collections-batch-run/:calendarYear/',

  // payment school class product editor
  'payments:school-class-product-editor-index':
    '/content/admin/payments/school-class-product-editor/:calendarYear/',
  'payments:school-class-product-editor':
    '/content/admin/payments/school-class-product-editor/:calendarYear/:schoolId/',
  'payments:school-classes-with-products':
    '/api/v1/payment/school_classes_with_products/:schoolId/:calendarYear/',
  'payments:school-class-products-bulk-update':
    '/api/v1/payment/school_class_products/',
  'payments:school-classes-bulk-update':
    '/api/v1/payment/school_classes_bulk_update/',

  // sales leads
  'sales-leads:report': '/sales-lead/report/',
  'setup-teacher-trial-page': '/content/admin/setup-teacher-trial/',
  'welcome-emails-page': '/content/admin/welcome-emails/',
  // fulfilment
  'fulfilment:review': '/content/admin/fulfilment-review/',

  //data exports
  'profile-exports:schools': '/api/v1/profile/export/schools/',
  'profile-exports:teachers': '/api/v1/profile/export/teachers/',
  'profile-exports:student-purchases':
    '/api/v1/profile/export/students/purchases/',
  'profile-exports:student-purchases-year':
    '/api/v1/profile/export/students/purchases/:calendarYear/',
  'profile-exports:student-purchases-school':
    '/api/v1/profile/export/students/purchases/:schoolId/',
  'profile-exports:student-purchases-school-year':
    '/api/v1/profile/export/students/purchases/:schoolId/:calendarYear/',
};
